import React, { Fragment } from "react";
import { Grid, IconButton, TextField, Typography, Slider, Checkbox, Divider } from "@material-ui/core";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import { withStyles } from "@material-ui/styles";
import SketchField from "../util/sketch/SketchField";
import Tools from "../util/sketch/tools";

import {
  Undo,
  Redo,
  Delete,
  FileCopy,
  Remove,
  PanTool,
  InsertPhoto,
  Brush,
  SelectAll,
  CheckBoxOutlineBlank,
  RadioButtonUnchecked,
  BrushOutlined,
  ZoomIn,
  ZoomOut,
  TextFormat,
  RotateRight,
} from "@material-ui/icons";

const fabric = require("fabric").fabric;

const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    margin: 6,
    border: "none",
    padding: 6,
    "&:not(:first-child)": {
      borderRadius: 10,
    },
    "&:first-child": {
      borderRadius: 10,
    },
  },
}))(ToggleButtonGroup);

class Paint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lineWidth: 2,
      textSize: 20,
      textAngle: 0,
      lineColor: "black",
      fillColor: "black",
      backgroundColor: "transparent",
      tool: Tools.None,
      enableRemoveSelected: false,
      enableCopyPaste: false,
      fillWithColor: false,
      fillWithBackgroundColor: false,
      canUndo: false,
      canRedo: false,
      text: "",
      sketch: this.props.sketch,
      stretched: true,
      stretchedX: false,
      stretchedY: false,
      originX: "left",
      originY: "top",
    };
  }

  _selectTool = (e, newValue) => {
    if (!newValue) {
      this.setState({
        tool: Tools.None,
      });
      return;
    }
    this.setState({
      tool: newValue,
      enableRemoveSelected: newValue === Tools.Select,
      enableCopyPaste: newValue === Tools.Select,
    });
    if (newValue === Tools.Text) {
      this.isDown = true;
      var pointer = this._sketch._fc.getPointer(e);
      var canvas = this._sketch._fc;
      let options = {
        fontFamily: "iranyekan",
        fontWeight: 500,
        fontSize: this.state.textSize,
        left: pointer.x,
        top: pointer.y,
      };

      this.iText = new fabric.IText(this.state.text, options);
      this.iText.rotate(this.state.textAngle);
      canvas.add(this.iText);
    }
  };

  componentDidMount = () => {
    if (this.state.sketch) this.loadImage();
  };

  _undo = () => {
    this._sketch.undo();
    this.setState({
      canUndo: this._sketch.canUndo(),
      canRedo: this._sketch.canRedo(),
    });
  };

  _redo = () => {
    this._sketch.redo();
    this.setState({
      canUndo: this._sketch.canUndo(),
      canRedo: this._sketch.canRedo(),
    });
  };

  _clear = () => {
    this._sketch.clear();
    this._sketch.setBackgroundFromDataUrl("");
    this.setState({
      controlledValue: null,
      backgroundColor: "transparent",
      fillWithBackgroundColor: false,
      canUndo: this._sketch.canUndo(),
      canRedo: this._sketch.canRedo(),
    });
  };

  _removeSelected = () => {
    this._sketch.removeSelected();
  };

  _onSketchChange = () => {
    let prev = this.state.canUndo;
    let now = this._sketch.canUndo();
    if (prev !== now) {
      this.setState({ canUndo: now });
    }
  };

  _addText = () => {
    if (this.state.text) {
      this._sketch.addText(this.state.text, {
        fontFamily: "IRANSans",
        fontWeight: 500,
        fontSize: this.state.textSize,
      });
      this.setState({ tool: Tools.Select, text: "" });
    }
  };
  dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);

    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  loadImage = () => {
    this._sketch.fromJSON(this.props.sketch);
  };

  onMouseMove = (e) => {
    if (this.state.tool === Tools.Text) {
      if (!this.isDown) return;

      var pointer = this._sketch._fc.getPointer(e);
      var canvas = this._sketch._fc;

      this.iText.rotate(this.state.textAngle);
      this.iText.set({
        left: pointer.x,
        top: pointer.y,
        fontSize: this.state.textSize,
      });

      this.iText.setCoords();
      canvas.renderAll();
    }
  };

  onMouseUp = (e) => {
    if (this.state.tool === Tools.Text) {
      this.isDown = false;
      this.setState({ tool: Tools.None, text: "", textAngle: 0 });
    }
  };

  textAngleAdd = (e) => {
    this.setState((prevState) => ({
      textAngle: prevState.textAngle + 90,
    }));
  };

  render() {
    return (
      <Fragment>
        <Grid container direction='column'>
          <Grid container direction='row' wrap='nowrap'>
            <Grid item>
              <Grid container direction='column' style={{ paddingLeft: 10 }}>
                <StyledToggleButtonGroup
                  orientation='vertical'
                  size='small'
                  value={this.state.tool}
                  exclusive
                  onChange={this._selectTool}
                  aria-label='text alignment'
                >
                  <ToggleButton value={Tools.Select}>
                    <SelectAll />
                  </ToggleButton>
                  <ToggleButton value={Tools.Pencil}>
                    <Brush />
                  </ToggleButton>
                  <ToggleButton value={Tools.Eraser}>
                    <BrushOutlined />
                  </ToggleButton>
                  <ToggleButton value={Tools.Line}>
                    <Remove />
                  </ToggleButton>
                  <ToggleButton value={Tools.Rectangle}>
                    <CheckBoxOutlineBlank />
                  </ToggleButton>
                  <ToggleButton value={Tools.Circle}>
                    <RadioButtonUnchecked />
                  </ToggleButton>
                  <ToggleButton value={Tools.Pan}>
                    <PanTool />
                  </ToggleButton>
                  <ToggleButton value={Tools.Text} disabled={!this.state.text}>
                    <TextFormat />
                  </ToggleButton>
                </StyledToggleButtonGroup>
              </Grid>
            </Grid>

            <Grid
              item
              style={{
                border: "2px #757575 solid",
                borderRadius: 25,
                overflow: "hidden",
                backgroundColor: "#fff",
                width: 400,
                height: 400,
              }}
              onMouseMove={(e) => this.onMouseMove(e)}
              onMouseUp={(e) => this.onMouseUp(e)}
            >
              <SketchField
                name='sketch'
                width={400}
                height={400}
                ref={(c) => (this._sketch = c)}
                lineColor={this.state.lineColor}
                lineWidth={this.state.lineWidth}
                fillColor={this.state.fillWithColor ? this.state.fillColor : "transparent"}
                backgroundColor={this.state.fillWithBackgroundColor ? this.state.backgroundColor : "transparent"}
                onChange={this._onSketchChange}
                tool={this.state.tool}
              />
            </Grid>

            <Grid item>
              <Grid container direction='column' alignContent='center' style={{ marginRight: 10 }}>
                <IconButton color='secondary' disabled={!this.state.crookie_url} onClick={this.loadImage}>
                  <InsertPhoto />
                </IconButton>
                <IconButton onClick={(e) => this._sketch.zoom(1.25)}>
                  <ZoomIn />
                </IconButton>
                <IconButton onClick={(e) => this._sketch.zoom(0.8)}>
                  <ZoomOut />
                </IconButton>
                <IconButton color='secondary' disabled={!this.state.canUndo} onClick={this._undo}>
                  <Undo />
                </IconButton>
                <IconButton color='secondary' disabled={!this.state.canRedo} onClick={this._redo}>
                  <Redo />
                </IconButton>
                <IconButton color='secondary' onClick={this._clear} style={{ marginBottom: 20 }}>
                  <Delete />
                </IconButton>
                <IconButton
                  color='secondary'
                  disabled={!this.state.enableCopyPaste}
                  onClick={(e) => {
                    try {
                      this._sketch.copy();
                      this._sketch.paste();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  <FileCopy />
                </IconButton>

                <IconButton
                  color='secondary'
                  disabled={!this.state.enableRemoveSelected}
                  onClick={this._removeSelected}
                >
                  <Remove />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction='column' style={{ marginTop: 5 }}>
            <Grid container direction='row' justifyContent='center' alignItems='center'>
              <Grid item>
                <Typography style={{ fontSize: 13 }} id='slider'>
                  ضخامت اشکال: {this.state.lineWidth}
                </Typography>
              </Grid>
              <Grid item style={{ flexGrow: 1, margin: "0px 20px" }}>
                <Slider
                  min={1}
                  max={30}
                  aria-labelledby='slider'
                  color='secondary'
                  value={this.state.lineWidth}
                  onChange={(e, v) => this.setState({ lineWidth: v })}
                />
              </Grid>
              <Grid item>
                <Checkbox
                  size='small'
                  checked={this.state.fillWithColor}
                  onChange={() => {
                    this.setState((prevState) => ({
                      fillWithColor: !prevState.fillWithColor,
                    }));
                  }}
                  aria-labelledby='checkbox'
                />
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: 13 }} id='checkbox'>
                  اشکال توپر
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Divider orientation='horizontal' />

          <Grid container direction='row' alignItems='center' style={{ marginTop: 10 }}>
            <Grid item style={{ flexGrow: 1, paddingLeft: 10 }}>
              <TextField
                disabled={this.state.tool === Tools.Text}
                label='یک متن بنویسید'
                onChange={(e) => this.setState({ text: e?.target?.value?.toPersianDigits() })}
                value={this.state.text}
                variant='outlined'
                size='small'
                fullWidth
              />
            </Grid>
            <Grid item>
              <TextField
                label='سایز متن'
                type='number'
                style={{ width: 80, marginLeft: 10 }}
                fullWidth
                InputProps={{ inputProps: { min: 10 } }}
                onChange={(e) => this.setState({ textSize: e.target.value })}
                value={this.state.textSize}
                variant='outlined'
                size='small'
              />
            </Grid>
            <Grid item>
              <IconButton disabled={!this.state.text} color='secondary' size='small' onClick={this.textAngleAdd}>
                <RotateRight />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default Paint;
